// Generated from assets/icons/tab-bar-activity-active-red.svg (TA-11013).
// Ids are derived per instance via useSvgIdPrefix() so two copies on one
// screen cannot collide. Edit this file rather than re-adding the .svg.
import * as React from 'react';
import Svg, { Path, Defs, LinearGradient, Stop } from 'react-native-svg';

import { useSvgIdPrefix } from '@hooks/useSvgIdPrefix';

import type { SvgProps } from 'react-native-svg';

export const TabBarActivityActiveRed = (props: SvgProps) => {
  const uid = useSvgIdPrefix();
  return (
    <Svg width={24} height={24} fill='none' viewBox='0 0 24 24' {...props}>
      <Path
        fill={`url(#${uid}-a)`}
        d='M3.464 20.536C2 19.07 2 16.713 2 12s0-7.071 1.464-8.536C4.93 2 7.287 2 12 2s7.071 0 8.536 1.464C22 4.93 22 7.287 22 12s0 7.071-1.464 8.536C19.07 22 16.713 22 12 22s-7.071 0-8.536-1.464'
      />
      <Path
        stroke='#035B60'
        strokeLinecap='round'
        strokeLinejoin='round'
        d='M6.45 11.985h2.49L10.934 8l2.99 7.97 1.992-3.985h2.49'
      />
      <Path
        fill='#FF4444'
        stroke='#FF4444'
        strokeWidth={1.25}
        d='M22 4.5a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0Z'
      />
      <Defs>
        <LinearGradient
          id={`${uid}-a`}
          x1={5.5}
          x2={27}
          y1={4.5}
          y2={27}
          gradientUnits='userSpaceOnUse'>
          <Stop stopColor='#97D8C6' />
          <Stop offset={1} stopColor='#32866F' />
        </LinearGradient>
      </Defs>
    </Svg>
  );
};
